import type { ItemPolicyEvaluateItemResultWire } from 'businessTraveller/api/requestPostItemPolicyEvaluate'

type ItemPolicyEvaluationRowWire = ItemPolicyEvaluateItemResultWire['rowsByEmployee'][number]

export function mapItemPolicyEvaluationRow(
  row: ItemPolicyEvaluationRowWire,
): App.BusinessTraveller.ItemPolicyEvaluationRow {
  return {
    employeeId: row.employeeId,
    verdict: row.verdict,
    itemPolicyId: row.itemPolicyId,
    policyName: row.policyName,
    applicableBudget: row.applicableBudget,
    currencyCode: row.currencyCode,
    decisionSource: row.decisionSource,
    budgetComparisonPercent: row.budgetComparisonPercent ?? null,
    // Budget-only lines (no cost sent) come back with creditValue null; treat as zero earn.
    creditValue: row.creditValue ?? 0,
    budgetCompliance: row.budgetCompliance,
  }
}

/** Maps one per-item evaluation result (rows + budget-bar presenter blocks) to the stored domain shape. */
export function mapItemPolicyEvaluationResult(
  result: ItemPolicyEvaluateItemResultWire,
): App.BusinessTraveller.ItemPolicyEvaluationResult {
  return {
    itemPolicyType: result.itemPolicyType,
    currencyCode: result.currencyCode,
    rowsByEmployee: result.rowsByEmployee.map(mapItemPolicyEvaluationRow),
    travellers: result.travellers.map(traveller => ({
      employeeId: traveller.employeeId,
      hasPolicy: traveller.hasPolicy,
      perNightPerRoom: 'perNightPerRoom' in traveller ? traveller.perNightPerRoom : null,
      perRoomAmount: 'perRoomAmount' in traveller ? traveller.perRoomAmount : null,
      perLeg: 'perLeg' in traveller ? traveller.perLeg : null,
      perDay: 'perDay' in traveller ? traveller.perDay : null,
      currencyCode: traveller.currencyCode,
      policyName: traveller.policyName,
    })),
    summary: { ...result.summary },
  } as App.BusinessTraveller.ItemPolicyEvaluationResult
}
